module.exports = __webpack_public_path__ + "rodapenov.png?656354b9a5be98186667a24d22c98f63";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/rodapenov.png
// module id = 136
// module chunks = 0